import React, { useState, useEffect } from "react";
import Scrollbar from "../../../scrollbar";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../utils/redux/hooks";
import { RootState } from "../../../../utils/redux/store";
import { addviewOrder } from "../../../../utils/redux/mainSlice";
import { formatDate } from "../tempFour";
import { fetchOrderDetails } from "../../../../utils/apis/func";
import { toast } from "react-toastify";

export type StatusColors = {
  pending: string;
  accepted: string;
  inprogress: string;
  "in dispute": string;
  track: string;
  completed: string;
  declined: string;
  cancelled: string;
};

export function formatDateOnly(dateString: string) {
  const date = new Date(dateString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  } as Intl.DateTimeFormatOptions;
  return date.toLocaleString("en-US", options);
}

export const getStatusColor = (status: keyof StatusColors): string => {
  const statusColors: StatusColors = {
    pending: "bg-yellow-700",
    accepted: "bg-green-500",
    inprogress: "bg-blue-500",
    "in dispute": "bg-red-500",
    track: "bg-purple-500",
    completed: "bg-teal-500",
    declined: "bg-gray-500",
    cancelled: "bg-red-500",
  };
  return statusColors[status] || "bg-gray-500"; // Default to gray if status is not found
};
export const exportToCsv = ({
  data,
  headers,
  keys,
  fileName,
}: {
  data: any[];
  headers: string[];
  keys: string[];
  fileName: string;
}) => {
  // Function to escape values containing commas or double quotes
  const escapeValue = (value: string) => {
    if (
      typeof value === "string" &&
      (value.includes(",") || value.includes('"'))
    ) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  // Create CSV content with escaped values
  const csvContent =
    "data:text/csv;charset=utf-8," +
    [headers.map(escapeValue).join(",")]
      .concat(
        data.map((row) => keys.map((key) => escapeValue(row[key])).join(","))
      )
      .join("\n");

  // Encode the CSV content and create a download link
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const AllOrders = ({
  selectedTab,
  user,
}: {
  selectedTab?: string;
  user?: any;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const customerOrders = useAppSelector(
    (store: RootState) => store.user.customerOrders
  );

  const itemsPerPage = 15;
  const totalItems = customerOrders?.length;

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const filterParam = selectedTab?.toLocaleLowerCase()?.includes("all")
    ? ""
    : selectedTab;

  const filteredItemsToShow = customerOrders
    ?.filter((item) => {
      return (
        filterParam === "" ||
        item?.status?.toLowerCase() === filterParam?.toLowerCase()
      );
    })
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  const headers = [
    "Date",
    "Amount",
    "Order ID",
    "Service Provider",
    "Job Description",
    "Address",
    "Location",
    "Status",
  ];

  const keys = [
    "createdAt",
    "totalPrice",
    "_id",
    "serviceProvider._id",
    "description",
    "address",
    "location",
    "status",
  ];



  const handleExportClick = () => {
    const itemToExport = filteredItemsToShow.map((item) => {
      return { ...item, createdAt: formatDateOnly(item.createdAt) };
    });
    exportToCsv({
      data: itemToExport,
      headers,
      keys,
      fileName: "pureworkerExport.csv",
    });
  };

  const query = useLocation();
  const viewCustomer: any = useAppSelector(
    (store: RootState) => store.user.viewCustomer
  );

  function extractId(pathname: string) {
    const parts = pathname.split("/");
    return parts[2]; // The ID will be the third part in the array
  }

  console.log("QUERy", query, extractId(query?.pathname));

  const id = extractId(query?.pathname);

  const fetchData = async (item: { _id: any; id: any }) => {
    try {
      const res: any = await fetchOrderDetails(item?._id || item?.id);
      console.log("here:", res?.data?.data);
      dispatch(addviewOrder(res?.data?.data));
      navigate("/customers/orderDetails");
    } catch (error) {
      console.log("");
    }
  };
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="overflow-auto ">
      <section className="mt-2">
        <div className="flex flex-row justify-between">
          <input
            type="search"
            className="border m-6 border-gray-300 rounded-full px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="Search by order id"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="bg-[#88087B] my-auto ml-auto px-8 rounded-md text-white text-s font-medium"
            onClick={() => {
              if (
                id
                // || viewCustomer?._id || viewCustomer?.id
              ) {
                navigate(
                  `/referrals/customize/${
                    id
                    // ?? viewCustomer?._id ?? viewCustomer?.id
                  }`
                );
              } else {
                toast("UserID undefined!.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  type: "error",
                });
              }
            }}
          >
            Customize ReferralCode
          </button>
        </div>
        <div className="overflow-auto  rounded-t-lg">
          <table
            className="w-full table-auto"
            style={{ width: "100% !important" }}
          >
            <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-sm lg:text-base font-medium text-center whitespace-nowrap space-x-4 lg:space-x-0">
              <tr className="whitespace-nowrap">
                <th className="py-6 text-center gap-2">Date</th>
                <th className="py-3">Amount</th>
                <th className="py-3"> ID</th>
                <th className="py-3">
                  {query?.pathname?.includes("customers")
                    ? "Service Provider"
                    : "Customers"}
                </th>
                <th className="py-3 max-w-sm">Services</th>
                <th className="py-3  max-w-sm">Job Description</th>
                <th className="py-3">Address</th>
                <th className="py-3">Location</th>
                <th className="py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredItemsToShow
                ?.filter((item: any) =>
                  `${item._id}`
                    .toLowerCase()
                    ?.includes(searchTerm.toLowerCase())
                )
                .map((item) => (
                  <tr
                    onClick={() => {
                      console.log(item);
                      fetchData(item);
                    }}
                    key={item?._id}
                    className="hover:bg-[#87878d]  transition duration-300 font-roboto text-xs font-medium leading-normal border border-b-[#525050] text-center"
                  >
                    <td className=" py-4whitespace-nowrap">
                      {formatDate(item?.createdAt)}
                    </td>
                    <td className="whitespace-nowrap">
                      {item?.totalPrice.toLocaleString() ||
                        item?.amount.toLocaleString()}
                    </td>
                    <td className="whitespace-nowrap">{item?._id}</td>
                    <td className="whitespace-nowrap">
                      {query?.pathname?.includes("customers")
                        ? `${
                            item?.serviceProvider?.businessName ||
                            item?.serviceProvider?.fullName
                          } `
                        : // ? `${item?.serviceProvider?.firstName} ${item?.serviceProvider?.lastName}`
                          `${item?.user?.firstName} ${item?.user?.lastName}`}
                    </td>
                    <td className="p-2 max-w-md">{item?.service?.name}</td>
                    <td className="p-2 max-w-md">{item?.description}</td>
                    <td className="whitespace-nowrap">{item?.address}</td>
                    <td className="whitespace-nowrap">{item?.location}</td>
                    <td className="whitespace-nowrap">
                      <p
                        className={`text-white px-2 py-1 rounded-lg ${getStatusColor(
                          item?.status.toLowerCase() as keyof StatusColors
                        )}`}
                      >
                        {item?.status}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {filteredItemsToShow.length < 1 && (
            <div className="py-8">
              <p className="font-bold text-2xl text-center">
                No Data to display
              </p>
            </div>
          )}
        </div>
        <div className="flex justify-end px-4 mt-8 -mb-8">
          <button
            onClick={() => {
              console.log("Export clicked");
              handleExportClick();
            }}
            className="bg-[#88087B] border border-[#88087B] px-2 rounded-md text-[#FFCD1E] text-center text-shadow font-roboto text-base font-medium leading-normal"
          >
            Export
          </button>
        </div>
        <Scrollbar
          currentPage={currentPage}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
        />
      </section>
    </div>
  );
};

export default AllOrders;
